import {
  DocumentTextIcon,
  PhotoIcon,
  VideoCameraIcon,
  Squares2X2Icon,
  RectangleStackIcon,
  QuestionMarkCircleIcon,
  PaperClipIcon,
  TableCellsIcon,
  Bars3Icon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { ComponentType } from '../../../types/elearning';

interface ComponentPaletteProps {
  onSelectComponent: (type: ComponentType) => void;
}

const componentTypes: Array<{
  type: ComponentType;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  description: string;
}> = [
  {
    type: 'text',
    label: 'Text',
    icon: DocumentTextIcon,
    description: 'Rich text content',
  },
  {
    type: 'heading',
    label: 'Heading',
    icon: DocumentTextIcon,
    description: 'H1-H6 headings',
  },
  {
    type: 'image',
    label: 'Image',
    icon: PhotoIcon,
    description: 'Image from WordPress',
  },
  {
    type: 'video',
    label: 'Video',
    icon: VideoCameraIcon,
    description: 'YouTube video',
  },
  {
    type: 'columns',
    label: 'Columns',
    icon: Squares2X2Icon,
    description: '2 or 3 column layout',
  },
  {
    type: 'card',
    label: 'Card',
    icon: RectangleStackIcon,
    description: 'Card with image & text',
  },
  {
    type: 'knowledge-check',
    label: 'Knowledge Check',
    icon: QuestionMarkCircleIcon,
    description: 'Interactive question',
  },
  {
    type: 'resource',
    label: 'Resource',
    icon: PaperClipIcon,
    description: 'Downloadable file',
  },
  {
    type: 'table',
    label: 'Table',
    icon: TableCellsIcon,
    description: 'Data table',
  },
  {
    type: 'accordion',
    label: 'Accordion',
    icon: Bars3Icon,
    description: 'Expandable FAQ',
  },
  {
    type: 'callout',
    label: 'Callout',
    icon: ExclamationTriangleIcon,
    description: 'Alert box',
  },
];

export default function ComponentPalette({ onSelectComponent }: ComponentPaletteProps) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">Add Component</h3>
      <div className="grid grid-cols-2 gap-2 max-h-96 overflow-y-auto">
        {componentTypes.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.type}
              onClick={() => onSelectComponent(item.type)}
              className="flex flex-col items-center gap-2 p-3 border border-gray-200 rounded-lg hover:border-primary hover:bg-primary/5 transition-colors text-left"
            >
              <Icon className="h-6 w-6 text-gray-600" />
              <div className="text-center">
                <p className="text-sm font-medium text-gray-900">{item.label}</p>
                <p className="text-xs text-gray-500">{item.description}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

